<div class="error-container" [ngStyle]="{'width': width}" *ngIf="error">
  <div class="error-body">
    <mat-icon class="error-icon align-middle">error_outline</mat-icon>
    {{ error | translate:locale.language }}
  </div>

  <button class="error-button" mat-raised-button color="primary" (click)="onRetry()"
    [attr.data-test]="'retry-button'">
    {{ 'Retry' | translate:locale.language }}
  </button>
</div>
